module.exports = __webpack_public_path__ + "static/lungo-bd659e82e2dbc0a3f5797a19400fecfa.png";